import api from './api';
import { Role, PermissionDef } from '../types';

export const rolesService = {
  getRoles: async (): Promise<Role[]> => {
    const res = await api.get('/roles');
    return res.data.roles || [];
  },
  getPermissions: async (): Promise<PermissionDef[]> => {
    const res = await api.get('/roles/permissions');
    return res.data.permissions || [];
  },
  createRole: async (name: string, permissions: string[]) => {
    const res = await api.post('/roles', { name, permissions });
    return res.data;
  },
  updateRolePermissions: async (id: string, permissions: string[]) => {
    const res = await api.put(`/roles/${id}/permissions`, { permissions });
    return res.data;
  },
  deleteRole: async (id: string) => {
    const res = await api.delete(`/roles/${id}`);
    return res.data;
  },
  assignRoleToUser: async (userId: string, roleId: string) => {
    const res = await api.post('/roles/assign', { userId, roleId });
    return res.data;
  }
};